import React from "react";
import { DataNotFoundIcon } from "../images";
import { dataMessages } from "../helpers/messages";

const DataNotFound = (props) => {
  return (
    <div className={`tc-datanot-found ${props?.className}`}>
      <img src={DataNotFoundIcon} alt={dataMessages.nodata} />
      <p>{props?.name ? props.name : dataMessages.nodata}</p>
    </div>
  );
};

export default DataNotFound;
